import { render } from "./NavBarSegment.vue?vue&type=template&id=ee7f75c4&scoped=true"
const script = {}

import "./NavBarSegment.vue?vue&type=style&index=0&id=ee7f75c4&scoped=true&lang=css"

import exportComponent from "/home/carlos/dev/libre-sube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7f75c4"]])

export default __exports__